import { IConfigData, IComponentProps } from "@/pages/dashboard/components/PageContainer/type";
import { useCallback, useMemo, useState } from 'react';

export const useProps = (props: IComponentProps): IComponentProps => {
  // 直接解构写法可能会有属性缺失而报错所以这里重新赋值替代之前的解构写法
  const cData = props?.config?.data ?? {};
  const propsData = props?.data ?? {};
  const propsChangeData = props?.changeData;
  const [_data, _setData] = useState<undefined | IConfigData>(cData);

  // 组装data，props.data、_data
  const data = useMemo(() => {
    return {
      ...(propsData || {}),
      ...(_data || {}),
    };
  }, [_data, propsData]);

  // 封装changeData，处理data的变更
  const changeData = useCallback((name: string, value: any) => {
    // eslint-disable-next-line no-prototype-builtins
    if (_data?.hasOwnProperty(name)) {
      _setData({
        ..._data,
        [name]: value
      });
    } else {
      propsChangeData?.(name, value);
    }
  }, [_data, propsChangeData]);

  return {
    ...props,
    data,
    changeData
  };
};
